import styled from 'styled-components';
import { margin, MarginProps, padding, PaddingProps } from 'styled-system';

export const ErrorContainer = styled.div<PaddingProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  ${padding};
`;

export const RetryButton = styled.div<MarginProps>`
  ${margin};
`;
